<template>
    <div v-if="permissions">
        <v-tooltip top
                   max-width="400"
                   open-delay="200"
                   v-if="getDangerousPermissions(permissions).length > 0">
            <template v-slot:activator="{ on }">
                <v-icon
                    class="ml-2"
                    v-on="on"
                    color="yellow darken-4">
                    mdi-alert
                </v-icon>
            </template>
            <span>
                Contains potentially dangerous permission(s):
                <br>
                <v-chip v-for="permission in getDangerousPermissions(permissions)"
                        :key="permission.name"
                        color="yellow darken-4"
                        class="mt-2 mb-2 mr-2"
                        label>
                    {{ permission.toUpperCase() }}
                </v-chip>
                <br>
                Make sure only appropriate people are give this role
            </span>
        </v-tooltip>
    </div>
</template>

<script>

import {dangerousPermissionsMixin} from "../../../components/mixins/dangerousPermissionsMixin";

export default {

    mixins: [dangerousPermissionsMixin],

    props: {
        permissions: {
            type: Array,
            required: false,
        }
    },
}

</script>